import { ReportGroup } from '@/api/generatedApi';
import { Box, Typography } from '@mui/material';
import { pluralize } from '@/utils/format';
import { AssetThumbnailGrid } from '@/components/AssetThumbnailGrid/AssetThumbnailGrid';

export const SourceGroupDisplay = ({ group, groupName }: { group: ReportGroup; groupName: string }) => {
  return (
    <Box
      sx={{
        mb: 2,
        p: 2,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '6px',
        backgroundColor: 'action.hover',
      }}
    >
      <Typography variant='subtitle2' sx={{ mb: 1, fontWeight: 600 }}>
        Merging from: {groupName}
      </Typography>
      <Typography variant='body2' color='text.secondary' sx={{ mb: 1 }}>
        {pluralize(group.assetIds.length, 'asset', 'assets')}
      </Typography>
      <AssetThumbnailGrid assetIds={group.assetIds} tenantId={group.tenantId} thumbnailSize={48} />
    </Box>
  );
};
